import Make from './make'

const make = Make('code/')

type DownloadType = 'account' | 'user' | 'adobe'

function getDownloadAsCsvLink(type: DownloadType) {
  const token = make.getToken()
  if (!token) return ''
  if (type === 'adobe') {
    return make.getEndpoint(`download-saint-file/${token}`)
  }
  if (type === 'account') {
    return make.getEndpoint(`download-account-created-codes/${token}`)
  }
  return make.getEndpoint(`download-user-created-codes/${token}`)
}

interface NewOptions {
  optionName: string
  optionValue: string
}
export interface OptionsProps {
  // newOptions: string[]
  // parameterName: string

  fieldID: string
  fieldName: string
  newOptions: NewOptions[]
}

export const getAdobeCodesDownloadLink = () => getDownloadAsCsvLink('adobe')
